import { render, staticRenderFns } from "./document-viewer.vue?vue&type=template&id=5cfd4318&scoped=true&"
import script from "./document-viewer.vue?vue&type=script&lang=js&"
export * from "./document-viewer.vue?vue&type=script&lang=js&"
import style0 from "./document-viewer.vue?vue&type=style&index=0&id=5cfd4318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd4318",
  null
  
)

component.options.__file = "document-viewer.vue"
export default component.exports